import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Skeleton } from './ui/Skeleton';

/**
 * Guards a subtree: requires a logged-in user.
 *   - While the initial /me probe is in flight → minimal splash.
 *   - No user → <Navigate to="/login"> with `from` state so we can bounce back after login.
 */
export function RequireAuth({ children }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        className="lk-page"
        style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 12, minHeight: '60vh' }}
        aria-busy="true"
        aria-label="Проверка авторизации"
      >
        <Skeleton w="30%" h={28} />
        <Skeleton w="60%" h={14} />
        <Skeleton w="100%" h={220} radius={12} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

export default RequireAuth;
